import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const GenericSelect = ({ label, value, onChange, options, disabledCondition = (item) => false, formControlWidth, sx, none, slotProps }) => {
  return (
    <FormControl sx={{ width: formControlWidth || "50%" }}>
      <InputLabel id={`${label}-label`} sx={{ color: "var(--text-secondary)", "&.MuiInputLabel-shrink": { padding: "0 5px", background: "var(--bg-page)", color: "var(--text-secondary)" } }}>
        {label}
      </InputLabel>
      <Select labelId={`${label}-label`} id={`${label}-select`} value={value} onChange={onChange} sx={sx}>
        {none && <MenuItem value="">
          <em>None</em>
        </MenuItem>}
        {options.map((item, index) => (
          item && <MenuItem key={item.value !== undefined ? item.value : index} disabled={disabledCondition(item)} value={item.value}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GenericSelect;